import { html } from 'lit-html';
import i18n from 'i18next';
import { templateToolbarTime } from '../../../../shared/components/toolbarTime/toolbarTime.template';

const MyEsiosWidget9 = () => {
  return html`
    <div
      class="col-sm-6 col-xs-6 mypFacturacionWidgetView"
      id="mypFacturacionWidgetView"
    >
      <div class="esios-toolbar col-12" style="z-index: 1">
        <div class="esios-toolbar9"></div>
        ${templateToolbarTime('volumen')}
      </div>
      <div id="spinner9" class="spinner-container">
        <div class="spinner"></div>
      </div>
      <div class="row container-w9">
        <div id="widget9">
          <div id="mypGraphic4" class="chari-chart aspect myp-aspect"></div>
        </div>
        <div
          id="mypNoDataRect4"
          class="esios-home__no-data-container_cuadrado hidden"
        >
          ${i18n.t('no-data-available')}
        </div>
        <ul class="esios-listEnergyItems__list">
          <div class="row"></div>
        </ul>
      </div>

      <div class="col-xs-24 col-sm-24 mt-5"></div>
    </div>
  `;
};

export default MyEsiosWidget9;
